import { FileUploadConfig } from '@buffer-mono/uploader'
import type { UploaderRestrictions } from '@buffer-mono/uploader'

export const AUTO_CLOSE_TIMEOUT = 3000
export const FEEDBACK_API_URL =
  'https://buffer-feedback-form.bufferapp.workers.dev'

/**
 * The two questions the form asks. These are used both as the visible field
 * labels and as the markers in the submitted `content` string, so a row in the
 * feedback sheet can be split back into its two answers later. Changing the
 * wording changes the format of every row written from then on.
 *
 * @see formatFeedbackContent in ./hooks/useFeedbackForm
 */
export const SUMMARY_QUESTION = 'What got in your way, and what might help?'
export const CONTEXT_QUESTION = 'What were you trying to do?'

/**
 * A summary shorter than this is almost never actionable. It is the length at
 * which single words, throwaway placeholders and bare usernames are rejected
 * while the shortest genuine suggestions still pass.
 */
export const MIN_SUMMARY_LENGTH = 20

/**
 * The same floor for scripts where one character carries closer to a word than
 * a letter. "I cannot schedule posts" is 23 characters; the same sentence in
 * Japanese is 10 and in Chinese 8, so holding those to MIN_SUMMARY_LENGTH
 * rejected most real feedback written in them.
 */
export const MIN_SUMMARY_LENGTH_DENSE_SCRIPT = 8

/**
 * The cap on each answer. Both fields carry it, so neither question reads as
 * the roomy one. It is enforced on the textarea and shown as a counter, so the
 * limit is visible while someone types rather than reported once they stop.
 */
export const MAX_ANSWER_LENGTH = 300

export const MAX_ATTACHMENTS = 5
export const MAX_FILE_SIZE_MB = 50
export const ACCEPTED_FILE_TYPES = 'image/*,video/*'

export const FEEDBACK_UPLOADER_RESTRICTIONS: UploaderRestrictions = {
  maxNumberOfFiles: MAX_ATTACHMENTS,
  allowedFileTypes: ['image/*', 'video/*'],
  uploadConfig: FileUploadConfig.MEDIA,
}
